(function (angular) {
    "use strict";

    /**
     * module stBtnTypes - Streamline Standard Button Types
     * 
     * directive stBtnType - allows to modify a button adding classes, icon and text based on the button type.
     *
     * st-btn-type:     string. Button Type name.
     *                          Required.
     * st-btn-deferred: empty.  Is this a deferred action button or not? It adds dots (...) to the button text.
     *                          Optional.
     * 
     * Note: If a text is specified into the button tag, it overrides the default button text.
     */

    angular
        .module("stBtnTypes", [])
        .directive("stBtnType", directive);

    var buttonTypeDefs = {
        "search": { text: "Search", btnClasses: ["btn", "btn-primary"], iconClasses: "glyphicon glyphicon-search" },
        "clear": { text: "Clear", btnClasses: ["btn", "btn-default"], iconClasses: "glyphicon glyphicon-refresh" },
        "cancel": { text: "Cancel", btnClasses: ["btn", "btn-default"], iconClasses: "glyphicon glyphicon-remove" },
        "add": { text: "Add", btnClasses: ["btn", "btn-primary"], iconClasses: "glyphicon glyphicon-plus" },
        "create": { text: "Create", btnClasses: ["btn", "btn-primary"], iconClasses: "glyphicon glyphicon-plus" },
        "view": { text: "View", btnClasses: ["btn", "btn-success"], iconClasses: "glyphicon glyphicon-fullscreen" },
        "edit": { text: "Edit", btnClasses: ["btn", "btn-primary"], iconClasses: "glyphicon glyphicon-edit" },
        "save": { text: "Save", btnClasses: ["btn", "btn-primary"], iconClasses: "glyphicon glyphicon-floppy-disk" },
        "update": { text: "Update", btnClasses: ["btn", "btn-primary"], iconClasses: "glyphicon glyphicon-floppy-disk" },
        "delete": { text: "Delete", btnClasses: ["btn", "btn-danger"], iconClasses: "glyphicon glyphicon-trash" },
        "export": { text: "Export", btnClasses: ["btn", "btn-success"], iconClasses: "glyphicon glyphicon-save" },
        "print": { text: "Print", btnClasses: ["btn", "btn-primary"], iconClasses: "glyphicon glyphicon-print" },
        "sign": { text: "Sign", btnClasses: ["btn", "btn-primary"], iconClasses: "glyphicon glyphicon-pencil" }
    };

    function directive($compile) {
        return {
            restrict: "A",
            scope: true,
            link: function (scope, element, attr) {
                var btnDefs = buttonTypeDefs[attr.stBtnType];
                if (!btnDefs) {
                    return;
                }

                btnDefs.btnClasses.forEach(function (btnClass) {
                    if (!element.hasClass(btnClass)) {
                        element.addClass(btnClass);
                    }
                });

                var buttonText = element.text().trim() || btnDefs.text;
                var deferredText = "";
                if ("stBtnDeferred" in attr) {
                    deferredText = "...";
                    element.removeAttr("st-btn-deferred");
                }

                var innerHtml = `<span class="` + btnDefs.iconClasses + `"></span>&nbsp;<span>` + buttonText + `</span>` + deferredText;
                element.html(innerHtml);

                $compile(element.contents())(scope);
            }
        };
    }

    directive.$inject = ["$compile"];

})(angular);